var map = {
	"./C1.png": 5510,
	"./C2.png": 4824,
	"./C3.png": 5949,
	"./C4.png": 3008,
	"./C5.png": 6198,
	"./C6.png": 2001,
	"./C7.png": 3242,
	"./C8.png": 8840,
	"./C9.png": 7405
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7827;